import logoApple from '../../assets/img/logos/apple.png';
import logoG from '../../assets/img/logos/g.png';
import logoIntel from '../../assets/img/logos/intel.png';
import logoNike from '../../assets/img/logos/nike.png';
import logoSamsung from '../../assets/img/logos/samsung.png';
import logoCocacola from '../../assets/img/logos/cocacola.png';
import logoNvidia from '../../assets/img/logos/nvidia.png';
import logoHP from '../../assets/img/logos/hp.png';

export default [
  { imgSrc: logoApple, title: 'Apple', description: '3243 associates', to: '#!' },
  { imgSrc: logoG, title: 'Google', description: '34598 associates', to: '#!' },
  { imgSrc: logoIntel, title: 'Intel', description: '7652 associates', to: '#!' },
  { imgSrc: logoNike, title: 'Nike', description: '765 associates', to: '#!' },
  { imgSrc: logoSamsung, title: 'Samsung', description: '54 associates', to: '#!' },
  { imgSrc: logoCocacola, title: 'Cocacola', description: '487 associates', to: '#!' },
  { imgSrc: logoNvidia, title: 'Nvidia', description: '98732 associates', to: '#!' },
  { imgSrc: logoHP, title: 'Hewlett Packard', description: '2345 associates', to: '#!' }
];
